export enum AuthActionType {
  OPEN_REGISTRATION = 'OPEN_REGISTRATION',
  OPEN_MODALWINDOW = 'OPEN_MODALWINDOW',
  CLOSE_MODAL = 'CLOSE_MODAL',
  OPEN_MAIlCONFIRMATION = 'OPEN_MAIlCONFIRMATION',
  OPEN_FIO = 'OPEN_FIO',
  OPEN_CREATEPASSWORD = 'OPEN_CREATEPASSWORD',
  SIGNIN_MODAL = 'SIGNIN_MODAL',
  OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL',
  CHECK_EMAIL_FORGOT_MODAL = 'CHECK_EMAIL_FORGOT_MODAL',

  SIGN_UP_FAIL = 'SIGN_UP_FAIL',
  SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS',
  SIGN_UP_REQUEST = 'SIGN_UP_REQUEST',

  SIGN_IN_FAIL = 'SIGN_IN_FAIL',
  SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS',
  SIGN_IN_REQUEST = 'SIGN_IN_REQUEST',

  SIGN_UP_CONFIRM_CODE_FAIL = 'SIGN_UP_CONFIRM_CODE_FAIL',
  SIGN_UP_CONFIRM_CODE_REQUEST = 'SIGN_UP_CONFIRM_CODE_REQUEST',
  SIGN_UP_CONFIRM_CODE_SUCCESS = 'SIGN_UP_CONFIRM_CODE_SUCCESS',

  ON_CHANGE_EMAIL = 'ON_CHANGE_EMAIL',
  ON_CHANGE_PASSWORD = 'ON_CHANGE_PASSWORD',

  FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL',
  FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',

  CONFIRM_PASSWORD_FAIL = 'CONFIRM_PASSWORD_FAIL',
  CONFIRM_PASSWORD_SUCCESS = 'CONFIRM_PASSWORD_SUCCESS',
  CONFIRM_PASSWORD_REQUEST = 'CONFIRM_PASSWORD_REQUEST',

  SIGN_OUT_FAIL = 'SIGN_OUT_FAIL',
  SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS',
  SIGN_OUT_REQUEST = 'SIGN_OUT_REQUEST',

  ON_CHANGE_CODE = 'ON_CHANGE_CODE',
  RESET_SIGN_IN_ERROR = 'RESET_SIGN_IN_ERROR',
  PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION',

  GET_SESSION_REQUEST = 'GET_SESSION_REQUEST',
  GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS',
  GET_SESSION_FAIL = 'GET_SESSION_FAILURE',
}

export interface OnChangeEmailAction {
  type: AuthActionType.ON_CHANGE_EMAIL;
  payload: { email: string };
}
export interface OnChangePasswordAction {
  type: AuthActionType.ON_CHANGE_PASSWORD;
  payload: { password: string };
}
export interface OnChangeCodeAction {
  type: AuthActionType.ON_CHANGE_CODE;
  payload: { code: string };
}
export interface ResertSignInErrrorAction {
  type: AuthActionType.RESET_SIGN_IN_ERROR;
}

export interface SignUpConfirmCodeRequestAction {
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_REQUEST;
  payload: { email: string; code: string };
}
export interface SignUpConfirmCodeFailAction {
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_FAIL;
  payload: any;
}
export interface SignUpConfirmCodeSuccessAction {
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_SUCCESS;
}

export interface SignOutFailAction {
  type: AuthActionType.SIGN_OUT_FAIL;
  payload: Error;
}
export interface SignOutSuccessAction {
  type: AuthActionType.SIGN_OUT_SUCCESS;
}
export interface SignOutRequestAction {
  type: AuthActionType.SIGN_OUT_REQUEST;
}

export interface SignUpFailAction {
  type: AuthActionType.SIGN_UP_FAIL;
  payload: any;
}
export interface SignUpSuccessAction {
  type: AuthActionType.SIGN_UP_SUCCESS;
}
export interface SignUpRequestAction {
  type: AuthActionType.SIGN_UP_REQUEST;
  payload: { email: string; password: string };
}

export interface SignInRequestAction {
  type: AuthActionType.SIGN_IN_REQUEST;
  payload: { email: string; password: string };
}
export interface SignInSuccessAction {
  type: AuthActionType.SIGN_IN_SUCCESS;
}
export interface SignInFailAction {
  type: AuthActionType.SIGN_IN_FAIL;
  payload: any;
}

export interface ForgotPasswordRequestAction {
  type: AuthActionType.FORGOT_PASSWORD_REQUEST;
  payload: { email: string };
}
export interface ForgotPasswordFailAction {
  type: AuthActionType.FORGOT_PASSWORD_FAIL;
  payload: any;
}
export interface ForgotPasswordSuccessAction {
  type: AuthActionType.FORGOT_PASSWORD_SUCCESS;
}

export interface ConfirmPasswordSuccessAction {
  type: AuthActionType.CONFIRM_PASSWORD_SUCCESS;
}
export interface ConfirmPasswordFailAction {
  type: AuthActionType.CONFIRM_PASSWORD_FAIL;
  payload: any;
}
export interface ConfirmPasswordRequestAction {
  type: AuthActionType.CONFIRM_PASSWORD_REQUEST;
  payload: { password: string; email: string; code: string };
}

export interface SignINModalAction {
  type: AuthActionType.SIGNIN_MODAL;
}
export interface openRegistrationAction {
  type: AuthActionType.OPEN_REGISTRATION;
}
export interface openModalWindowAction {
  type: AuthActionType.OPEN_MODALWINDOW;
}
export interface closeModalAction {
  type: AuthActionType.CLOSE_MODAL;
}
export interface mailConfirmationAction {
  type: AuthActionType.OPEN_MAIlCONFIRMATION;
  payload: { email: string };
}
export interface fioAction {
  type: AuthActionType.OPEN_FIO;
}
export interface openCreatePasswordAction {
  type: AuthActionType.OPEN_CREATEPASSWORD;
}
export interface openForgotPasswordModalAction {
  type: AuthActionType.OPEN_FORGOT_PASSWORD_MODAL;
  payload: { email: string };
}
export interface CheckEmailForgotModalAction {
  type: AuthActionType.CHECK_EMAIL_FORGOT_MODAL;
}
export interface PasswordConfirmationAction {
  type: AuthActionType.PASSWORD_CONFIRMATION;
  payload: { password: string };
}
export type AuthAction =
  | openRegistrationAction
  | openModalWindowAction
  | closeModalAction
  | mailConfirmationAction
  | fioAction
  | openCreatePasswordAction
  | SignUpFailAction
  | SignUpSuccessAction
  | SignUpRequestAction
  | SignInRequestAction
  | SignInFailAction
  | SignInSuccessAction
  | OnChangeEmailAction
  | OnChangePasswordAction
  | OnChangeCodeAction
  | ForgotPasswordFailAction
  | ForgotPasswordRequestAction
  | ForgotPasswordSuccessAction
  | ConfirmPasswordFailAction
  | ConfirmPasswordRequestAction
  | ConfirmPasswordSuccessAction
  | OnChangeCodeAction
  | SignUpConfirmCodeFailAction
  | SignUpConfirmCodeRequestAction
  | SignUpConfirmCodeSuccessAction
  | SignINModalAction
  | openForgotPasswordModalAction
  | CheckEmailForgotModalAction
  | ResertSignInErrrorAction
  | SignOutFailAction
  | SignOutSuccessAction
  | SignOutRequestAction
  | PasswordConfirmationAction;

export const passwordConfirmationAction = (password): PasswordConfirmationAction => ({
  type: AuthActionType.PASSWORD_CONFIRMATION,
  payload: { password },
});
export const signOutFail = (error: Error): SignOutFailAction => ({
  type: AuthActionType.SIGN_OUT_FAIL,
  payload: error,
});
export const signOutRequest = (): SignOutRequestAction => ({
  type: AuthActionType.SIGN_OUT_REQUEST,
});

export const signOutSuccess = (): SignOutSuccessAction => ({
  type: AuthActionType.SIGN_OUT_SUCCESS,
});
export const resertSignInErrror = (): ResertSignInErrrorAction => ({
  type: AuthActionType.RESET_SIGN_IN_ERROR,
});
export const signINModalAction = (): SignINModalAction => ({
  type: AuthActionType.SIGNIN_MODAL,
});
export const openRegistrationAction = (): openRegistrationAction => ({
  type: AuthActionType.OPEN_REGISTRATION,
});
export const openModalWindowAction = (): openModalWindowAction => ({
  type: AuthActionType.OPEN_MODALWINDOW,
});
export const closeModalAction = (): closeModalAction => ({
  type: AuthActionType.CLOSE_MODAL,
});
export const mailConfirmationAction = (email: string): mailConfirmationAction => ({
  type: AuthActionType.OPEN_MAIlCONFIRMATION,
  payload: { email },
});
export const fioAction = (): fioAction => ({
  type: AuthActionType.OPEN_FIO,
});
export const openCreatePasswordAction = (): openCreatePasswordAction => ({
  type: AuthActionType.OPEN_CREATEPASSWORD,
});
export const openForgotPasswordModalAction = (email: string): openForgotPasswordModalAction => ({
  type: AuthActionType.OPEN_FORGOT_PASSWORD_MODAL,
  payload: { email },
});
export const checkEmailForgotModalAction = (): CheckEmailForgotModalAction => ({
  type: AuthActionType.CHECK_EMAIL_FORGOT_MODAL,
});
export const signUpFail = (error: any): SignUpFailAction => ({
  type: AuthActionType.SIGN_UP_FAIL,
  payload: error,
});
export const signUpSuccess = (): SignUpSuccessAction => ({
  type: AuthActionType.SIGN_UP_SUCCESS,
});
export const signUpRequest = (email: string, password: string): SignUpRequestAction => ({
  type: AuthActionType.SIGN_UP_REQUEST,
  payload: { email, password },
});
export const signInRequest = (email: string, password: string): SignInRequestAction => ({
  type: AuthActionType.SIGN_IN_REQUEST,
  payload: { email, password },
});
export const signInSuccess = (): SignInSuccessAction => ({
  type: AuthActionType.SIGN_IN_SUCCESS,
});
export const signInFail = (error: any): SignInFailAction => ({
  type: AuthActionType.SIGN_IN_FAIL,
  payload: error,
});
export const onChangeEmail = (email: string): OnChangeEmailAction => ({
  type: AuthActionType.ON_CHANGE_EMAIL,
  payload: { email },
});

export const onChangePassword = (password: string): OnChangePasswordAction => ({
  type: AuthActionType.ON_CHANGE_PASSWORD,
  payload: { password },
});
export const onChangeCode = (code: string): OnChangeCodeAction => ({
  type: AuthActionType.ON_CHANGE_CODE,
  payload: { code },
});

export const forgotPasswordSuccess = (): ForgotPasswordSuccessAction => ({
  type: AuthActionType.FORGOT_PASSWORD_SUCCESS,
});

export const forgotPasswordFail = (error: any): ForgotPasswordFailAction => ({
  type: AuthActionType.FORGOT_PASSWORD_FAIL,
  payload: error,
});
export const forgotPasswordRequest = (email: string): ForgotPasswordRequestAction => ({
  type: AuthActionType.FORGOT_PASSWORD_REQUEST,
  payload: { email },
});
export const confirmPasswordFail = (error: any): ConfirmPasswordFailAction => ({
  type: AuthActionType.CONFIRM_PASSWORD_FAIL,
  payload: error,
});
export const confirmPasswordSuccess = (): ConfirmPasswordSuccessAction => ({
  type: AuthActionType.CONFIRM_PASSWORD_SUCCESS,
});
export const confirmPasswordRequest = (
  email: string,
  password: string,
  code: string,
): ConfirmPasswordRequestAction => ({
  type: AuthActionType.CONFIRM_PASSWORD_REQUEST,
  payload: { email, password, code },
});

export const signUpConfirmCodeFail = (error: any): SignUpConfirmCodeFailAction => ({
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_FAIL,
  payload: error,
});
export const signUpConfirmCodeSuccess = (): SignUpConfirmCodeSuccessAction => ({
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_SUCCESS,
});
export const signUpConfirmCodeRequest = (email: string, code: string): SignUpConfirmCodeRequestAction => ({
  type: AuthActionType.SIGN_UP_CONFIRM_CODE_REQUEST,
  payload: { email, code },
});
